import { LoadingButton } from '@mui/lab'
import React, { useState } from 'react'
import GenerateIcon from '../../components/GenerateIcon'
import { saveAs } from "file-saver"
import ItemsRequestsApp from './ItemsRequestsApp'
import { handleRequestError } from '../../services/api'
import { useDispatch } from 'react-redux'
import { updateQuickNotificationDetails } from '../notifications/notificationsSlice'
import { Checkbox, FormControlLabel, TextField } from '@mui/material'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

interface IProps {
    requestNumber: string
}

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export default function ExportRequest(props: IProps) {

    const dispatch = useDispatch()

    const {
        requestNumber
    } = props

    const [sendingRequest, setSendingRequest] = useState<boolean>(false)
    const [remarks, setRemarks] = useState<string>("")

    const [customReceivingBy, setCustomReceivingBy] = useState<string>("")
    const [customReceivedBy, setCustomReceivedBy] = useState<string>("")
    const [itemsCondition, setItemsCondition] = useState<string>("")
    const [hideRequestDetails, setHideRequestDetails] = useState<boolean>(false)
    const [includeThumbnails, setIncludeThumbnails] = useState<boolean>(false)
    const [tabId, setTabId] = useState<number>(0)

    const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
        setTabId(newValue)
    }

    const a11yProps = (index: number) => {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const CustomTabPanel = (props: TabPanelProps) => {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {/* {value === index && <Box sx={{ p: 3 }}>{children}</Box>} */}
                {value === index && <div className="tabpanel-content">{children}</div>}
            </div>
        );
    }

    const itemsRequestApp = new ItemsRequestsApp()

    const handleResetForm = () => {
        setRemarks("")
        setCustomReceivingBy("")
        setItemsCondition("")
        setHideRequestDetails(false)
        setCustomReceivedBy("")
        setIncludeThumbnails(false)
    }

    const handleExportToPdf = (export_type: string) => {

        setSendingRequest(true)

        itemsRequestApp.exportItemsRequestToPdf(
            requestNumber, 
            export_type, 
            remarks,
            itemsCondition,
            hideRequestDetails,
            customReceivingBy,
            customReceivedBy,
            includeThumbnails
        )
            .then(response => {
                setSendingRequest(false)
    
                const blob = response.data;
    
                const contentDisposition = response.headers["content-disposition"]
                let fileName = "exported_items.xlsx"

                console.log("contentDisposition", contentDisposition)
                console.log('response.headers', response.headers, response)

                if (contentDisposition) {
                    const match = contentDisposition.match(/filename="(.+)"/)
                    if (match && match[1]) {
                        fileName = match[1]
                    }
                }
    
                saveAs(blob, fileName)
    
                updateQuickNotificationDetails(true, "The request has been exported successfully!", "success", dispatch);

                handleResetForm()
            })
            .catch(error => {
                setSendingRequest(false)
                handleRequestError(error, dispatch);
            }); 

    }

    if (!requestNumber){
        return <></>
    }

    const renderRemarks = () => {
        return(
                <TextField 
                    variant="outlined" 
                    label="Remarks" 
                    value={remarks} 
                    onChange={(e) => setRemarks(e.target.value)} 
                    fullWidth 
                    multiline
                    rows={4}
                    style={{ marginBottom: 10 }}
                />
        )
    }

    const renderIncludeThumbnailsBox = () => <FormControlLabel style={{ marginTop: 5 }} control={<Checkbox checked={includeThumbnails} onChange={(e) => setIncludeThumbnails(e.target.checked)} />} label="Include items thumbnails" />    

    return(
        <div className="export-request-boxes">


            <div className="tabs-of-single-request-requested-items-list-container">
                <Tabs value={tabId} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Export requested items" {...a11yProps(0)} />
                    <Tab label="Items Handover Form" {...a11yProps(1)} />
                    <Tab label="Return Items Form" {...a11yProps(2)} />
                </Tabs>
            </div>

            <CustomTabPanel value={tabId} index={0}>
                <div className="export-request-box">
                    <div className="content-of-export-request-box">

                        {/* <h3>Export requested items</h3> */}

                        {renderRemarks()}
                        <div style={{ marginBottom: 5 }}>
                            <FormControlLabel style={{ marginTop: 5 }} control={<Checkbox checked={hideRequestDetails} onChange={(e) => setHideRequestDetails(e.target.checked)} />} label="Hide request details" />    
                            {renderIncludeThumbnailsBox()}
                        </div>                    

                        <LoadingButton disabled={sendingRequest} className="general-button admin-style light-button" color="success" variant="contained" startIcon={<GenerateIcon icon="download" />} onClick={() => handleExportToPdf("requested_items")}>Download PDF</LoadingButton>

                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={tabId} index={1}>
                <div className="export-request-box">
                    <div className="content-of-export-request-box">

                        {/* <h3>Items Handover Form</h3> */}

                        <div className="form-of-export-request-box">
                            {renderRemarks()}
                            <TextField 
                                variant="outlined" 
                                label="Custom recipient" 
                                value={customReceivingBy} 
                                onChange={(e) => setCustomReceivingBy(e.target.value)} 
                                fullWidth 
                                style={{ marginBottom: 10 }}
                            />
                            {renderIncludeThumbnailsBox()}
                        </div>

                        <LoadingButton disabled={sendingRequest} className="general-button admin-style light-button" color="success" variant="contained" startIcon={<GenerateIcon icon="download" />} onClick={() => handleExportToPdf("handover_form")}>Download PDF</LoadingButton>

                    </div>
                </div>
            </CustomTabPanel>

            <CustomTabPanel value={tabId} index={2}>
                <div className="export-request-box">
                    <div className="content-of-export-request-box">

                        {/* <h3>Return Items Form</h3> */}

                        <div className="form-of-export-request-box">
                            <TextField 
                                variant="outlined" 
                                label="Items condition" 
                                value={itemsCondition} 
                                onChange={(e) => setItemsCondition(e.target.value)} 
                                fullWidth 
                                multiline
                                rows={4}
                                style={{ marginBottom: 10 }}
                            />
                            <TextField 
                                variant="outlined" 
                                label="Custom recipient" 
                                value={customReceivedBy} 
                                onChange={(e) => setCustomReceivedBy(e.target.value)} 
                                fullWidth 
                                style={{ marginBottom: 10 }}
                            />
                            {renderIncludeThumbnailsBox()}
                        </div>

                        <LoadingButton disabled={sendingRequest} className="general-button admin-style light-button" color="success" variant="contained" startIcon={<GenerateIcon icon="download" />} onClick={() => handleExportToPdf("return_form")}>Download PDF</LoadingButton>

                    </div>
                </div>
            </CustomTabPanel>

        </div>
    )
}